/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-named-as-default
*/
import DownloadPage from './download-page';

export default DownloadPage;
